var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-input-plus-minus" },
    [
      _c(
        "v-icon",
        {
          attrs: { color: _vm.value === 0 ? "gray" : "black" },
          on: { click: _vm.decrement },
        },
        [_vm._v("\n    remove\n  ")]
      ),
      _vm._v(" "),
      _c(
        "v-text-field",
        {
          attrs: {
            color: "secondary",
            id: _vm.id,
            type: "number",
            value: _vm.value,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            maxLength: _vm.maxLength,
            minLength: _vm.minLength,
          },
          on: { input: _vm.input, blur: _vm.blur, keypress: _vm.keypress },
        },
        [
          _c(
            "div",
            {
              class: { "required-field": _vm.isRequired },
              attrs: { slot: "label", id: _vm.id },
              slot: "label",
            },
            [_c("span", [_vm._v(_vm._s(_vm.label))])]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-icon",
        {
          attrs: { color: _vm.disabled ? "gray" : "black" },
          on: { click: _vm.increment },
        },
        [_vm._v("\n    add\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }